import { DRM_URL_TYPE, playerTypes } from '../config/constants';
import cdnHandler from './CDNHandler';
import h, { appData } from './common';
import LearnManager from './LearnManager';
import user from './user';
import { appConfig } from '../config/app.config';
import { log } from '@intigral/utils';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { getConfiguration } from '../hooks/useConfiguration';
import { CACHE_CONFIG_TYPES } from '@intigral/constant';
import { PlayerEvent, PlayerEventCallback } from 'bitmovin-player';
import type { Player, PlayerAPI } from 'bitmovin-player';
import type { IAdBreakData } from './CDNHandler';
import { isPlayerAlive } from './playerGuards';

interface Listener {
    el: EventTarget;
    fn: EventListener;
    e: string;
}

export interface PlayerService {
    timerObj: NodeJS.Timeout | null;
    learnManager: LearnManager | null;
    playerObj: PlayerAPI | null;
    initPlayer: any;
    player: PlayerAPI | null;
    isAdPlayed: boolean;
    adsData: IAdBreakData;
    setAdsData(val: any): void;
    getAdsData(): any;
    setIsAdPlayed(val: boolean): void;
    getIsAdPlayed(): boolean;
    getPlayerKey(): string | null;
    setPlayer(player: PlayerAPI, attachEvents?: boolean): void;
    setUpPlayer(player): any;
    getPlayer(): PlayerAPI | null;
    isLive(): boolean;
    cancelDestroyPlayer(): void;
    destroyPlayer(): void;
    toggleMute(): any;
    clearAdsData(): void;
    useCaseId: any;
    setUseCaseId: (e: any) => void;
}

const playerService: PlayerService = {
    playerObj: null,
    timerObj: null,
    learnManager: null,
    initPlayer: null,
    isAdPlayed: false,
    adsData: null,
    useCaseId: null,

    get player() {
        return this.playerObj;
    },

    set player(val) {
        this.playerObj = val;
    },

    setIsAdPlayed(val: boolean): void {
        this.isAdPlayed = val;
    },
    getIsAdPlayed(): boolean {
        return this.isAdPlayed;
    },

    setAdsData(val: IAdBreakData) {
        this.adsData = val;
    },

    getAdsData() {
        return this.adsData;
    },

    clearAdsData() {
        this.adsData = null;
        this.isAdPlayed = false;
    },

    getPlayerKey() {
        const config = getConfiguration();
        try {
            return config.player.bitmovin_app_key;
        } catch (e) {
            return null;
        }
    },

    setPlayer(player, attachEvents = true) {
        this.playerObj = player;
    },

    setUpPlayer(player) {
        this.initPlayer = player;
    },

    getPlayer() {
        return this.player;
    },

    isLive() {
        return isPlayerAlive(this.player) ? this.player.isLive() : false;
    },

    cancelDestroyPlayer() {
        if (this.timerObj) {
            clearTimeout(this.timerObj);
        }
    },

    destroyPlayer() {
        // Capture the instance now: by the time the timer fires `this.player` may already point to a
        // newer instance (or null) and the captured one may have been destroyed by its owner.
        const player = this.player;
        this.timerObj = setTimeout(() => {
            if (player && isPlayerAlive(player)) {
                player.unload().catch((e) => log.debug('[playerService] unload failed:', e));
            }
            if (this.player === player) this.player = null;
        }, 500);
    },

    toggleMute() {
        const player = this.player;
        if (!isPlayerAlive(player)) return;
        if (player.isMuted()) {
            player.unmute();
        } else {
            player.mute();
        }
    },

    setUseCaseId(useCaseId) {
        this.useCaseId = useCaseId;
    },
};

export default playerService;
